import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { ebookFlowSearchValidator } from "@/validators/ebook-flow";

export const Route = createFileRoute("/_app/create/ebook/flow")({
  validateSearch: zodValidator(ebookFlowSearchValidator),
});
